import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterListingPage_template extends vnTemplate {
    protected tagContainerId: string = 'filters-selected';
    protected tagContainerCaption: string = 'Selected Filters:';
    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search icon i-auto-complete i-listing-page-a" data-bind="css: { disable: disabled }">
                    <input data-bind="textInput: listingPage, event: { keyup: onChangeInput}, valueUpdate : 'afterkeydown', attr:{id:idListingPage, placeholder: placeholder}" list="listingPages" class="input-text">
                        <!-- ko if: isLoadingAnimationEnable() && optionsLoading() -->
                        <span class="form-loading" ></span>
                        <!-- /ko -->
                        <ul class="form-auto-list" data-bind="foreach: listingPages, visible: isShowListingPageSuggestions" id="listingPages">
                            <!-- ko ifnot: $parent.showDetails() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.name + ' (' + $data.permalink + ')', click: $parent.onBlurTag" ></li>
                            <!-- /ko -->
                            
                            <!-- ko if: $parent.showDetails() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, click: $parent.onBlurTag" >
                                <span class="title" data-bind="text: $data.name"></span>
                                <span class="date">ID: 
                                    <span data-bind="text: $data.id ?? ''"></span>
                                </span>
                                <span class="date">Permalink: 
                                    <span data-bind="text: $data.permalink"></span>
                                </span>
                            </li>
                            <!-- /ko -->
                        </ul>
                    </input>
                    <button data-bind="event: { click: onClearInput }, attr: {id: closeButtonId }" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterListingPage-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            listingPages: ko.observableArray([]),
            idListingPage: ko.observable(null),
            listingPage: ko.observable(""),
            listingPageObj: ko.observable(null),
            closeButtonId: self.getButtonCloseElementId(),
            placeholder: ko.observable('Listing Page'),
            orderBy: "dateCreation",
            orderByDirection: "DESC",
            isShowListingPageSuggestions: ko.observable(false),
            showDetails: ko.observable(false),
            isLoadingAnimationEnable: ko.observable(false),
            optionsLoading: ko.observable(false),
            disabled: ko.observable(false),
            onChangeInput: function (data, event) {
                self.onChangeInput(data, event);
            },
            onClearInput: function (data, event) {
                self.onClearInput(event);
            },
            onChangeFilterAction: function (data, event) {
                self.onChangeFilterAction(data)
            },
            onBlurTag: function (data, event) {
                self.onBlurTag(data, event);
            }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    public getButtonCloseElementId(): string {
        return this.idElement+'-input-close';
    }

    public setListingPageId(listingPageId): void {
        if (this.getTemplateViewModel().idListingPage() != listingPageId) {
            this.getTemplateViewModel().idListingPage(listingPageId);
            this.caller.getListingPageById(listingPageId, this.idElement);
        }
    }

    public setListingPage(data): void {
        if (!data) return;

        document.getElementById(this.getButtonCloseElementId()).classList.add('is-showing');
        this.getTemplateViewModel().listingPage(data.name + ' (' + data.permalink + ')');
        this.getTemplateViewModel().listingPageObj(data);
        this.getTemplateViewModel().idListingPage(data.id);
        this.getTemplateViewModel().listingPages([]);
        this.getTemplateViewModel().isShowListingPageSuggestions(false);
        this.addListingTag(data);
    }

    protected onChangeInput(data, event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        let closeBtn = inputWrapper.querySelector('#'+this.getButtonCloseElementId());
        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }
        this.getTemplateViewModel().optionsLoading(true);
        this.onChangeListingPageDataList(event, this.viewModel[this.idElement].idListingPage);
    }

    protected onChangeListingPageDataList(event, idListingPage) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("listingPages").childNodes;
        if (inputVal.length >= 2) {
            this.caller.getListingPagesSuggestion(inputVal, this.idElement);
            this.getTemplateViewModel().isShowListingPageSuggestions(true);

        }
        for (let op of options) {
            if (op.value === inputVal) {
                idListingPage(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event) {
        let button = event.target;
        if (button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
            this.viewModel[this.idElement].idListingPage(null);
            this.viewModel[this.idElement].listingPage("");
            this.viewModel[this.idElement].listingPages([]);
            this.viewModel[this.idElement].listingPageObj(null);
            this.viewModel[this.idElement].isShowListingPageSuggestions(false);
            this.getTagContainer().innerHTML = '';
            this.caller.filterSimpleOnChange(this.idElement);

        }
        this.getTemplateViewModel().optionsLoading(false);
    }

    public clearInput() {
        let button = document.getElementById(this.getButtonCloseElementId());
        if (button && button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
            this.viewModel[this.idElement].idListingPage(null);
            this.viewModel[this.idElement].listingPage("");
            this.viewModel[this.idElement].listingPages([]);
            this.viewModel[this.idElement].listingPageObj(null);
            this.viewModel[this.idElement].isShowListingPageSuggestions(false);
            //this.caller.filterSimpleOnChange(this.idElement);

        }
        this.getTemplateViewModel().optionsLoading(false);
    }

    protected onBlurTag(data, event) {
        this.getTemplateViewModel().listingPage(data.name + ' (' + data.permalink + ')');
        this.getTemplateViewModel().listingPageObj(data);
        this.getTemplateViewModel().idListingPage(data.id);
        this.getTemplateViewModel().listingPages([]);
        this.getTemplateViewModel().isShowListingPageSuggestions(false);
        this.addListingTag(data);
        this.caller.filterSimpleOnChange(this.idElement);
    }

    public toggleCloseButton(): void {

        let closeBtn = document.getElementById(this.getButtonCloseElementId());
        let idListingPage = this.getTemplateViewModel().idListingPage();

        if (idListingPage == null) {
            closeBtn.classList.remove('is-showing');
        } else {
            closeBtn.classList.add('is-showing');
        }
        this.getTemplateViewModel().optionsLoading(false);
    }

    public setPlaceholder(placeholder: string): void {
        this.getTemplateViewModel().placeholder(placeholder);
    }

    public setShowDetails(boolean){

        this.getTemplateViewModel().showDetails(boolean)
    }

    public setIsLoadingAnimationEnable(boolean){

        this.getTemplateViewModel().isLoadingAnimationEnable(boolean)
    }

    public setOptions(listingPages){

        this.getTemplateViewModel().optionsLoading(false);
        this.getTemplateViewModel().listingPages(listingPages)
    }

    protected hasHtmlTag(listing) {
        let has = false;
        let self = this;

        this.getTagContainer().querySelectorAll('button').forEach(function (element) {
            // @ts-ignore
            if (element.getAttribute('id') == listing.id) {
                has = true;
            }
        });

        return has;
    }

    protected createHtmlTag(listing) {

        let self = this;
        let element = document.createElement('button');

        element.setAttribute('id', listing.id);
        element.appendChild(document.createTextNode(`${listing.name} (${listing.permalink})`));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');

        element.addEventListener('click', function (e) {
            // @ts-ignore
            self.removeListingFromSelection(e.target.getAttribute('id'));
            // @ts-ignore
            self.getTagContainer().removeChild(e.target);
        }, false);

        return element;
    }

    removeListingFromSelection(listingId) {
        if (this.getTemplateViewModel().idListingPage() == listingId) {
            this.getTemplateViewModel().listingPage('');
            this.getTemplateViewModel().listingPageObj(null);
            this.getTemplateViewModel().idListingPage(null);
            this.getTemplateViewModel().listingPages([]);
            this.getTemplateViewModel().isShowListingPageSuggestions(false);
            this.getTagContainer().innerHTML = '';
            this.caller.filterSimpleOnChange(this.idElement);
        }
    }

    public addListingTag(listingPage) {
        this.addCaption();
        const tagContainer = this.getTagContainer(); 
        if (tagContainer) {
            if (!this.hasHtmlTag(listingPage))
                tagContainer.appendChild(this.createHtmlTag(listingPage));
        }
    }


    public setDisabled(disabled: boolean): void {
        this.getTemplateViewModel().disabled(disabled);
    }

    public getDisabled(): boolean {
        return this.getTemplateViewModel().disabled();
    }

    public setTagContainerId(id: string) {

        this.tagContainerId = id;
    }

    public setTagContainerCaption(caption: string) {

        this.tagContainerCaption = caption;
    }
    protected addCaption() {
        if (this.getTagContainer()) {
            if (!this.hasCaption()) {
                this.getTagContainer().appendChild(this.createCaption());
            }
        }
    }

    protected hasCaption(): boolean {
        let captions = this.getTagContainer().getElementsByTagName('label');

        return (captions.length > 0);

    }


    protected createCaption() {

        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.tagContainerCaption));

        return element;
    }

    protected getTagContainer() {
        const tagContainer = document.getElementById(this.tagContainerId);

        if (!tagContainer) {
            let tempContainer = document.createElement('div');
            return tempContainer;
        }

        return tagContainer;
    }

    public resetTagContainer(): void {
        if (this.getTagContainer()) {
            this.getTagContainer().innerHTML = '';
            this.getTemplateViewModel().listingPage('');
            this.getTemplateViewModel().listingPageObj(null);
            this.getTemplateViewModel().idListingPage(null);
            this.getTemplateViewModel().listingPages([]);
            this.getTemplateViewModel().isShowListingPageSuggestions(false);
        }
    }



}



// WEBPACK FOOTER //
// ./js/components/templates/filterListingPage_template.ts